export default "__VITE_ASSET__Csw_QxU2__"